import { FormattedMessage } from "react-intl";

export const MONTH_CONSTANT = [
  { value: 1, labelId: "Jan" },
  { value: 2, labelId: "Feb" },
  { value: 3, labelId: "Mar" },
  { value: 4, labelId: "Apr" },
  { value: 5, labelId: "May" },
  { value: 6, labelId: "Jun" },
  { value: 7, labelId: "Jul" },
  { value: 8, labelId: "Aug" },
  { value: 9, labelId: "Sep" },
  { value: 10, labelId: "Oct" },
  { value: 11, labelId: "Nov" },
  { value: 12, labelId: "Dec" },
];
